import React from 'react';

import { PaginationProps } from 'antd/lib/pagination';

import * as Styled from './Pagination.style';

export type Props = PaginationProps;

export const Pagination = (props: Props): JSX.Element => <Styled.Pagination {...props} />;
